const submissionOriginator = {
    UMS_MANUAL : 0,

    UMS_AUTO : 1,

    UPLOAD : 2,

    REWRITE : 3,

    UPLOAD_ACORD_PDF : 4,

    EXCHANGE : 5,

    EMAIL_RECEIVER : 6,

    COPY : 7,

    SPLIT : 8,

    EMAIL_UPLOAD : 9

};

angular.module('gw-um-j2js')
    .constant('submissionOriginator', submissionOriginator);